import { render } from "./check.vue?vue&type=template&id=24c12718&scoped=true"
import script from "./check.vue?vue&type=script&lang=ts"
export * from "./check.vue?vue&type=script&lang=ts"

import "./check.vue?vue&type=style&index=0&id=24c12718&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24c12718"

export default script